import React from 'react';
import moment from 'moment';
import { Field } from 'formik';
import DatePicker from '../DatePicker';

const formatDate = date => moment.utc(date).format('YYYY-MM-DD');

export const createDatePickerProps = (minDate, maxDate, frequency) => {
  const props = {
    formatDate,
  };

  // only add dates if they exist to prevent issues with date picker rendering
  // if we pass in null, undefined or a string, then an error is thrown so this
  // code prevents that from happening.

  if (minDate) {
    props.minDate = moment.utc(minDate).local(true).toDate();
  }

  if (maxDate) {
    props.maxDate = moment.utc(maxDate).local(true).toDate();
  }

  if (frequency === 'monthly') {
    props.formatDate = date => moment(date).format('YYYY-MM');
    props.monthOnly = true;
  }

  return props;
};

export const effectiveDateColumnListItem = () => {
  return {
    key: 'effectiveDate',
    name: 'Effective Date',
    minWidth: 130,
    maxWidth: 180,
    data: 'number',
    fieldName: 'effectiveDate',
    onRender(filter) {
      return <span>{moment(filter.effectiveDate).utc().format('MM/DD/YYYY')}</span>;
    },
  };
};

export const effectiveDateColumn = (minDate, maxDate, formikField = 'filters') => {
  return {
    key: 'effectiveDate',
    name: 'Effective Date',
    minWidth: 130,
    maxWidth: 180,
    onRender(filter, index) {
      // Don't allow the user to select an effective date that is after the termination date
      // so that we can always have a valid date range
      const props = createDatePickerProps(minDate, filter.terminationDate || maxDate);

      return (
        <Field
          name={`${formikField}.${index}.effectiveDate`}
          component={DatePicker}
          {...props}
          allowTextInput
        />
      );
    },
  };
};

export const expirationDateColumnListItem = () => {
  return {
    key: 'terminationDate',
    name: 'Expiration Date',
    minWidth: 130,
    maxWidth: 180,
    data: 'number',
    fieldName: 'terminationDate',
    onRender(filter) {
      return <span>{moment(filter.terminationDate).utc().format('MM/DD/YYYY')}</span>;
    },
  };
};

export const expirationDateColumn = (minDate, maxDate, formikField = 'filters') => ({
  key: 'terminationDate',
  name: 'Expiration Date',
  onRender(filter, index) {
    // disable dates before the filter's effectiveDate if it exists
    // only allow dates after the effective date to allow valid date ranges
    // only
    const props = createDatePickerProps(filter.effectiveDate || minDate, maxDate);

    return (
      <Field
        name={`${formikField}.${index}.terminationDate`}
        component={DatePicker}
        {...props}
        allowTextInput
      />
    );
  },
  minWidth: 130,
});
